import styled from 'styled-components'
import dynamic from 'next/dynamic'

import MainLayout from '../../layouts/MainLayout'
import AdsEmitterBanner from '../../components/AdsEmitterBanner'
import BoxedContainer from '../../components/BoxedContainer'
import AdsSortingFilters from '../../components/AdsSortingFilters'
import AdsGrid from '../../components/AdsGrid'
import Pagination from '../../components/Pagination'
import SectionWrapper from '../../components/SectionWrapper'
import { mq, sizes } from '../../theme'

const Map = dynamic(() => import('../../components/Map'), { ssr: false })

export const Layout = styled(MainLayout)`
  main {
    margin-top: 5rem;
  }
`

export const Container = styled(BoxedContainer)``

export const Banner = styled(AdsEmitterBanner)``

export const Filters = styled(AdsSortingFilters)``

export const Overflow = styled.div`
  width: 100%;
  overflow: auto;
`

export const List = styled.div`
  padding: 4rem 0 0 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  overflow: auto;

  @media ${mq(sizes.tablet)} {
    display: table;
    width: 100%;
    border-spacing: 0 2.5rem;
  }
`

export const GridAds = styled(AdsGrid)``

export const MapAds = styled(Map)`
  height: 40rem;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('tablet')} {
    height: 95rem;
  }
`

export const Centered = styled(SectionWrapper)`
  text-align: center;
  margin-bottom: 6rem;
`

export const PaginationStyled = styled(Pagination)`
  justify-content: center;
`
